import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	legendHeader: {
		id: 'portfolio-3-portfolio.app-export-view.main.legend.legend-header',
		defaultMessage: 'Legend',
		description: 'The label for legend component',
	},
	systemIconsLegendHeader: {
		id: 'portfolio-3-portfolio.app-export-view.main.legend.system-icons-legend-header',
		defaultMessage: 'System icons',
		description: 'The label for system icons legend',
	},
	scenarioChangesLegendHeader: {
		id: 'portfolio-3-portfolio.app-export-view.main.legend.scenario-changes-legend-header',
		defaultMessage: 'Scenario changes',
		description: 'The label for scenario changes legend',
	},
	dateFieldIcon: {
		id: 'portfolio-3-portfolio.app-export-view.main.legend.date-field-icon',
		defaultMessage: 'Start/end date field',
		description: 'The label for date field icon legend',
	},
	sprintInferredDateIcon: {
		id: 'portfolio-3-portfolio.app-export-view.main.legend.sprint-inferred-date-icon',
		defaultMessage: 'Date inferred from sprint',
		description: 'The label for sprint inferred date icon legend',
	},
	releaseInferredDateIcon: {
		id: 'portfolio-3-portfolio.app-export-view.main.legend.release-inferred-date-icon',
		defaultMessage: 'Date inferred from release',
		description: 'The label for release inferred date icon legend',
	},
	rolledUpValueIcon: {
		id: 'portfolio-3-portfolio.app-export-view.main.legend.rolled-up-value-icon',
		defaultMessage: 'Rolled-up value',
		description: 'The label for rolled-up value icon legend',
	},
	externalIcon: {
		id: 'portfolio-3-portfolio.app-export-view.main.legend.external-icon',
		defaultMessage: 'Teams and sprints currently not in this plan',
		description: 'The label for external icon legend',
	},
	unsavedCreatedIssues: {
		id: 'portfolio-3-portfolio.app-export-view.main.legend.unsaved-created-issues',
		defaultMessage: 'Unsaved created issues',
		description: 'The label for scenario unsaved created issues',
	},
	exportDisclaimerSpork: {
		id: 'portfolio-3-portfolio.app-export-view.main.legend.export-disclaimer-spork',
		defaultMessage: 'Exported on {date} | Powered by Jira',
		description: 'The label for export disclaimer',
	},
});
